<script setup lang="ts">
const store = usePortfolioStore()
const paths: Record<string, string> = {
  palette: 'M2.5 4h19v13h-19zM8 21h8M6 8h5M6 11h3M14 8l4 4-4 4',
  code: 'M2.5 4h19v13h-19zM8 21h8M9.5 9L8 11l1.5 2M14.5 9L16 11l-1.5 2',
  spark: 'M12 3l2.2 5.8L20 11l-5.8 2.2L12 19l-2.2-5.8L4 11l5.8-2.2z',
  gauge: 'M4 18a8 8 0 1116 0M12 14l4-4'
}
</script>

<template>
  <section id="services" class=" py-6">
    <h2 class="text-center text-2xl font-extrabold md:text-3xl">خدمات من</h2>
    <p class="mx-auto mt-2.5 max-w-md text-center text-[13px] leading-8 text-muted">
      هر پروژه را از تعریف مسئله تا تحویل نهایی همراهی می‌کنم.
    </p>
    <div class="mt-7 grid gap-3.5 sm:grid-cols-2 lg:grid-cols-3">
      <div v-for="s in store.services" :key="s.title" data-reveal
           class="bg-surface p-7 text-center transition duration-500 hover:-translate-y-1.5 hover:shadow-[var(--t-glow)]">
        <span class="mx-auto grid place-content-center text-accent">
          <svg viewBox="0 0 24 24" class="h-10 w-10" fill="none" stroke="currentColor" stroke-width="1.5"
               stroke-linecap="round" stroke-linejoin="round"><path :d="paths[s.icon] ?? paths.spark" /></svg>
        </span>
        <h3 class="mt-4 text-base font-bold">{{ s.title }}</h3>
        <p class="mt-2 text-[12.5px] text-muted">{{ s.description }}</p>
      </div>
    </div>
  </section>
</template>
